<div>
  <h2>Alert</h2>
  <h4>Your session is going to timeout, do you need more time?</h4>
  <div fxLayout="row" fxLayoutAlign="end">
    <button mat-raised-button color="primary" type="submit" (click)="onClickingYesButton()">Yes</button>
  </div>
</div>


